import { Downgraded, useHookstate } from '@hookstate/core'
import React, { useEffect } from 'react'
import { getStatisticsDispatchByDistrictService } from '~/features/Dispatch/services'
import ColumnChartVertical from '~/components/ColumnChartMui/VerticalChart'
import { calculateBarChartTotal } from '~/utils/format'

export default function DispatchByDistrictPieChart({
  operationId,
  initialDate,
  endDate,
  refresh,
  loading,
}) {
  const data = useHookstate([])

  useEffect(() => {
    loading.set(true)
    getStatisticsDispatchByDistrictService({
      operationId: operationId,
      initialDate: initialDate,
      endDate: endDate,
    })
      .then((response) => {
        const result = response.map((responseData) => ({
          item: responseData.name,
          value: responseData.total,
        }))
        return data.set(result)
      })
      .finally(() => {
        loading.set(false)
      })
  }, [refresh])

  return (
    // <PieChart data={data.attach(Downgraded).get()} title={'Graph of Occurrences by District'} sxFont={{ fontWeight: 'bold', fontSize: 16 }} />
    <ColumnChartVertical
      data={data.attach(Downgraded).get()}
      title={'Graph of Occurrences by District'}
      colorBar="tertiary"
      subtitle={`Total de ocorrência: ${calculateBarChartTotal(
        data.attach(Downgraded).get()
      )}`}
      typeTotal={'township'}
    />
  )
}
